module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1)], 1), _vm._v(" "), ((_vm.checkModule.indexOf('CC') >= 0)) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h5', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Existing CC Quotation")])]), _vm._v(" "), (_vm.hideButtn == false) ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px pull-right",
    on: {
      "click": _vm.openCC
    }
  }, [_vm._v("New CC Quotation")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "cc"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("CC Quotation")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ccTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (index == 0 ? 'color:green' : 'color:red'),
      on: {
        "click": function($event) {
          _vm.editCC(item1.ccQId)
        }
      }
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                  " + _vm._s(item1.ccQSeries) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(item1.validityDate)) + "\n                  "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.ccExpireStatus == 1 ? " (Expired)" : ""))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                  " + _vm._s(item1.ccStatus == '0' ? 'Pending' : item1.ccStatus == '1' ? 'Approved' : 'Rejected') + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                  " + _vm._s(item1.ccClientStatus == '0' ? 'Pending' : item1.ccClientStatus == '1' ? 'Approved' : 'Rejected') + "\n                ")]), _vm._v(" "), (index == '0' && item1.ccClientStatus != '2' && item1.ccClientStatus != '1') ? _c('td', [(item1.ccStatus != '1' && item1.sendHODApproveCC == '1') ? _c('b', [_vm._v("\n                    Sent For Approval\n                    "), _c('br')]) : (item1.ccStatus == '1' && item1.sendToEnquiryCC == '0') ? _c('b', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.openPop(item1)
        }
      }
    }, [_vm._v("\n                    Send To Enquiry Team\n                    "), _c('br')]) : (item1.ccStatus == '1' && item1.sendToEnquiryCC == '1') ? _c('b', [_vm._v("\n                    Already Sent to Enquiry\n                    "), _c('br')]) : _c('b', [_vm._v("\n                    N/A\n                    "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                    " + _vm._s(item1.ccClientStatus == '2' && index == 0 ? "Client Rejected" : item1.ccClientStatus == '1' && index == 0 ? "Client Approved" : "N/A") + "\n                    "), _c('br')])]), _vm._v(" "), _c('td', [(item1.ccQuotationPdf != '' && item1.ccQuotationPdf != null) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.ccQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")])], 1)])
  }))])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e01279a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewMainEnqQuotationCC.vue
// module id = 2491
// module chunks = 0